import * as angular from 'angular';
import FlowModelSummaryTagBridge from './FlowModelSummaryTagBridge';
angular
  .module('flowingly.components')
  .component('flowModelSummaryTag', FlowModelSummaryTagBridge);
